import LegalShell from "./LegalShell";

export default function Terms() {
    return (
        <LegalShell
            title="Kullanım Şartları"
            subtitle="Sayz hizmetlerinin kullanımını düzenleyen taraflar arası sözleşme hükümleridir."
            lastUpdated="24 Şubat 2026"
            testId="legal-terms"
        >
            <p className="lead">
                Sayz hizmetlerini kullanmaya başlamanız bu Kullanım Şartları'nı kabul ettiğiniz
                anlamına gelir. Lütfen hizmeti kullanmadan önce bu belgeyi dikkatle okuyunuz.
            </p>

            <h2>1. Taraflar ve Hizmet Tanımı</h2>
            <p>
                Bu sözleşme, <strong>Atamis Global Teknoloji A.Ş.</strong> ("Sayz") ile Sayz
                panelinde hesap açan ve/veya widget script'ini kendi web sitesinde yayınlayan
                tüzel kişi ("Müşteri") arasında akdedilmiştir.
            </p>
            <p>
                Sayz, e-ticaret sitelerine "Beden Tablosu" ve "Bedenimi Bul" widget'ları
                sunan kapalı devre bir B2B SaaS platformudur. Hizmetin özellikleri ve kota
                sınırları Sayz ile Müşteri arasındaki ayrı anlaşmada belirtilir.
            </p>

            <h2>2. Hesap Oluşturma ve Güvenlik</h2>
            <ul>
                <li>Sayz paneline giriş yalnızca <strong>OTP (tek seferlik parola)</strong> ile yapılır. Açık kayıt (self-signup) bulunmaz.</li>
                <li>Hesaplar <strong>sadece davet üzerine</strong> açılır ve kuruluş e-postanız ile ilişkilendirilir.</li>
                <li>OTP kodunuzu üçüncü taraflarla paylaşmamanız gerekmektedir. Hesabınızın güvenliğinden siz sorumlusunuz.</li>
                <li>Sayz, güvenlik şüphesi durumunda hesap erişimini askıya alma hakkını saklı tutar.</li>
            </ul>

            <h2>3. Lisans ve Kullanım Hakkı</h2>
            <p>
                Sayz, Müşteri'ye hizmet dönemi süresince <strong>münhasır olmayan,
                devredilemez, alt lisans verilemez</strong> bir kullanım hakkı tanır. Bu hak:
            </p>
            <ul>
                <li>Yalnızca Müşteri'nin kendi e-ticaret sitesinde kullanılabilir</li>
                <li>Üçüncü taraf siteleriyle paylaşılamaz, yeniden satılamaz</li>
                <li>Rakip ürün geliştirmek için ters mühendislik yapılamaz</li>
                <li>Script'in çıktısı başka bir SaaS'a dönüştürülemez</li>
            </ul>

            <h2>4. Kabul Edilebilir Kullanım</h2>
            <p>Sayz hizmetleri aşağıdaki amaçlarla kullanılamaz:</p>
            <ul>
                <li>Yasa dışı ürün satışı veya izinsiz üçüncü taraf veri toplama</li>
                <li>Sayz altyapısını aşırı yük (DDoS, scraping, otomatik bot trafiği) ile zorlama</li>
                <li>Yetkisiz erişim denemesi, güvenlik açığı istismarı</li>
                <li>Yanıltıcı/aldatıcı beden önerileri ile tüketiciyi mağdur etme</li>
                <li>İnsan vücudunu ima eden görsellerde kişilik haklarını ihlal</li>
            </ul>

            <h2>5. Ücretler ve Ödeme</h2>
            <p>
                Hizmet bedeli Müşteri ile Sayz arasında imzalanan anlaşmada belirtilen pakete
                göre peşin olarak faturalandırılır. KDV ayrıca eklenir. Ödeme süresi
                içinde yapılmayan hesaplar askıya alınabilir.
            </p>
            <ul>
                <li>Yıllık peşin ödeme %25 indirim avantajı sunar</li>
                <li>Deneme süresi 14 gün, kart gerektirmez, 50.000 etkileşim kotalı</li>
                <li>Kota aşımı manuel yönetilir — otomatik ücret kesilmez</li>
            </ul>

            <h2>6. Hizmet Seviyesi ve Kullanılabilirlik</h2>
            <p>
                Sayz, uptime ve veri bütünlüğü için ticari olarak makul çabayı gösterir
                ancak hiçbir SLA garantisi sunulmaz. Planlı bakım dönemleri önceden
                bildirilir. Beklenmeyen kesintiler için Sayz'ın sorumluluğu, kesinti
                dönemine denk gelen aylık ücret ile sınırlıdır.
            </p>

            <h2>7. Veri Mülkiyeti</h2>
            <ul>
                <li>Müşteri'nin panele girdiği tüm veriler (beden tabloları, model bilgileri, ürün eşleştirmeleri) <strong>Müşteri'ye aittir</strong>.</li>
                <li>Sayz bu veriler üzerinde yalnızca hizmetin sunulması için gerekli olduğu ölçüde işleme hakkı sahibidir.</li>
                <li>Hesap kapandığında Müşteri verileri 30 gün içinde tam ve kalıcı olarak silinir.</li>
                <li>Anonim aggregate istatistikler Sayz'ın ürün geliştirme amacıyla kullanabileceği şekilde kalır.</li>
            </ul>

            <h2>8. Fikri Mülkiyet</h2>
            <p>
                Sayz'ın yazılım kaynak kodu, algoritmaları, markası ve dokümantasyonu dahil
                her türlü fikri mülkiyet hakkı Atamis Global Teknoloji A.Ş.'ye aittir.
                Müşteri'nin bu haklar üzerinde herhangi bir mülkiyet iddiası yoktur.
            </p>

            <h2>9. Sorumluluk Sınırlaması</h2>
            <p>
                Yasa'nın izin verdiği azami ölçüde:
            </p>
            <ul>
                <li>Beden önerisi algoritmasının <strong>%100 doğruluk</strong> garantisi verilmez — iyileştirme amacıyla sunulur, satın alma kararı tüketiciye aittir.</li>
                <li>Dolaylı, arızi, cezai veya sonuca bağlı zararlardan Sayz sorumlu değildir.</li>
                <li>Toplam sorumluluk, zararın meydana geldiği aya denk gelen hizmet bedelini aşamaz.</li>
            </ul>

            <h2>10. Fesih</h2>
            <ul>
                <li>Taraflar hizmeti 30 gün yazılı ihtar ile feshedebilir.</li>
                <li>Fesih halinde ödenmiş ücretler iade edilmez ancak kalan dönem kullanılmaz.</li>
                <li>Kurallara ciddi aykırılık halinde Sayz hesabı derhal askıya alma hakkını saklı tutar.</li>
            </ul>

            <h2>11. Değişiklikler</h2>
            <p>
                Sayz, bu şartları önemli değişikliklerle güncellediğinde panel üzerinden
                ve e-posta ile 30 gün önceden bildirir. Değişiklikten sonra hizmetin
                kullanılmaya devam edilmesi yeni şartların kabulü anlamına gelir.
            </p>

            <h2>12. Uygulanacak Hukuk ve Yetkili Mahkeme</h2>
            <p>
                Bu sözleşmeye <strong>Türkiye Cumhuriyeti</strong> hukuku uygulanır.
                İhtilaflar <strong>İstanbul Anadolu Mahkemeleri ve İcra Daireleri</strong>'nin
                münhasır yetkisindedir.
            </p>

            <h2>13. İletişim</h2>
            <p>
                Sözleşmeye ilişkin tüm sorular için:{" "}
                <a href="mailto:hello@atamis.global">hello@atamis.global</a>
            </p>
        </LegalShell>
    );
}
